import { render, staticRenderFns } from "./CoalProducts.vue?vue&type=template&id=1f919a28&scoped=true&"
import script from "./CoalProducts.vue?vue&type=script&lang=js&"
export * from "./CoalProducts.vue?vue&type=script&lang=js&"
import style0 from "./CoalProducts.vue?vue&type=style&index=0&id=1f919a28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f919a28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VHover,VImg,VRow})
